import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack';
import { SnackbarUtilsConfigurator } from 'utils/SnackbarUtils';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import store from 'store/store';
import { Provider } from 'react-redux';
import App from './App';
import i18n from './i18n/config';

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
        <SnackbarUtilsConfigurator />
        <Provider store={store}>
          <App />
        </Provider>
      </SnackbarProvider>
    </I18nextProvider>

  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
